<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";   
import Multiselect from 'vue-multiselect'
export default {
  mixins: [Api, Sabit],
  page: {
    title: "Duyurular",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,   Multiselect
  },
  data() {
    return { 
      title: this.$t("userroles.title"),
      items: [
        {
          text: "Yetki İşlemleri",
          href: "/",
        },
        {
          text: this.$t("userroles.title"),
          active: true,
        },
      ],
      DefaultPage: 1,
      Page: {
        PageNumber: "1",
        PageSize: "9999",
        PageDataSize: "1",
      },
      PageToplu: {
        PageNumber: "1",
        PageSize: "9999",
        PageDataSize: "1",
      },
      Kullanicilar: {},
      KullanicilarTable: {},
      KullaniciRolleriGrup: {},
      KullaniciRolleri: {},
      KullaniciAra: null,
      YetkiAra: null,
      SeciliKullaniciYetkileri: {},
      SeciliYetkiKullaniciliari: {},
      Roles:[],
      KullanicilarArray:[],
      YetkiArray:[ ],
      Tab:1,
      ComboboxUser: [],
      user: []
    };
  },

  methods: {
    onSearchChange(name) {
      if (name.length > 2) {
        this.kullanici_yukle(name);
      }
    },

    kullanici_yukle(event){
     if(event && event.length > 2){ 
        this.user=[];
      this.ActionsFilterGet({
        Service: JSON.parse(localStorage.getItem("config")).API_ACCOUNT_URL + "Account/get-users",
          Page: this.PageToplu,
          Filter: "&name="+ event
      }).then((res) => {
        this.ComboboxUser = res.Data;
        for(var i=0; i<this.ComboboxUser.length;i++){
            this.user.push({ id: this.ComboboxUser[i].Email, 
              label: res.Data[i].FirstName+"   /" + res.Data[i].Email, })
          }
          this.user = [...this.user]; 
      });
    }

  },
    Get() { 
      this.KullaniciRolleri = [ ];
      this.KullanicilarArray = [ ]; 
      this.YetkiArray = [ ]; 

 

      this.ActionsGet({
        Service: JSON.parse(localStorage.getItem("config")).API_ACCOUNT_URL + "Account/get-roles",
        Page: this.PageToplu,
      }).then((res) => {
        res.Data = res.Data.sort(function (a, b) {return a.Title.localeCompare(b.Title);}); 
        this.KullaniciRolleriGrup = this.groupBy(res.Data, "Group");
        this.KullaniciRolleri = res.Data; 
        for(let i=0; i<res.Data.length; i++){  
          if(res.Data[i].Group == "Talep Yönetim Sistemi"){
                this.YetkiArray.push({
                id: res.Data[i].NormalizedName,
                label: res.Data[i].Name,
              });
          }
        }
      });
     
    },
    KullaniciYetkiSorgu(kullanici) {
      this.ActionsFilterGet({
        Service: JSON.parse(localStorage.getItem("config")).API_ACCOUNT_URL + "Account/get-userroles",
        Page: this.PageToplu,
        Filter: "&email=" + kullanici,
      }).then((res) => {
        this.SeciliKullaniciYetkileri = res.Data;
        this.Roles = res.Data.Roles
      });
    },
    YetkiKullaniciSorgu(yetki) { 
      this.ActionsFilterGet({
        Service:
          JSON.parse(localStorage.getItem("config")).API_ACCOUNT_URL + "Account/get-users-in-role",
        Page: this.PageToplu,
        Filter: "&role=" + yetki,
      }).then((res) => {
        this.SeciliYetkiKullaniciliari = res.Data;
      });
    },
    groupBy: function (array, key) {
      const result = {};
      array.forEach((item) => {
        if (!result[item[key]]) {
          result[item[key]] = [];
        }
        result[item[key]].push(item);
      });
      return result;
    },
    RolesPost(checked,value) {  
          let FormData = {
            Email: this.SeciliKullaniciYetkileri.Email,
            Role: value,
          }; 
      if(checked == true){ 
          this.Post(
            JSON.parse(localStorage.getItem("config")).API_ACCOUNT_URL + "Account/add-userroles",
            FormData
          );
      }else{
          this.Post(
            JSON.parse(localStorage.getItem("config")).API_ACCOUNT_URL + "Account/delete-userroles",
            FormData
          );
      }
    },
    
  },
  created() {
  
 
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.css"></style>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
  <div class="col-lg-12">
      <div class="card">
        <div class="card-body">
          <div class="card-body">
            <h5 class="h4 card-title">
              {{ $t("userroles.page.yetkiislemleri") }}
            </h5>
            <p class="card-title-desc">
              {{
                $t(
                  "userroles.page.kullanicilaricinyetkinedirmeveyetkilistelemeekrani"
                )
              }}
            </p>

            <b-tabs
              justified
              nav-class="nav-tabs-custom"
              content-class="p-3 text-muted" 
            >
              <b-tab active @click="Tab=1" >
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="fas fa-home"></i>
                  </span>
                  <span class="d-none d-sm-inline-block" >{{
                    $t("userroles.page.kullaniciyetkilendirme")
                  }}</span>
                </template>

                <div class="mx-5">
                  <h4 class="card-title">
                    {{ $t("userroles.page.kullaniciara") }}
                  </h4>
                  <p class="card-title-desc">
                    {{
                      $t(
                        "userroles.page.yetkilendirmekistediginizkullaniciyiseciniz"
                      )
                    }}
                  </p>  

                  
                  <div class="col-lg-12">
                    <multiselect v-model="KullaniciAra" :options="user" :searchable="true"
                      :placeholder="'Kullanıcı Ara...'" label="label" track-by="id" @search-change="onSearchChange" 
                      @select="KullaniciYetkiSorgu($event.id)"
                      :deselect-label="'Seçimi kaldır'" :selected-label="'Seçildi'" :select-label="'Seç'" />

                  </div>

 
                </div>
              </b-tab>

              <b-tab  @click="Tab=2">
                <template v-slot:title  >
                  <span class="d-inline-block d-sm-none">
                    <i class="far fa-user"></i>
                  </span>
                  <span class="d-none d-sm-inline-block"  >{{
                    $t("userroles.page.yetkilistele")
                  }}</span>
                </template>

                <div class="mx-5">
                  <h4 class="card-title">
                    {{ $t("userroles.page.yetkiler") }}
                  </h4>
                  <p class="card-title-desc">
                    {{
                      $t(
                        "userroles.page.yetkiyebaglikullanicilarigormekcinsecimyapin"
                      )
                    }}
                  </p>
                  <div class="col-lg-12">

                    
                    <multiselect v-model="YetkiAra" :options="YetkiArray" :searchable="true"
                      :placeholder="'Seçiniz...'" label="label" track-by="id"
                      @select="YetkiKullaniciSorgu($event.id)" :deselect-label="'Seçimi kaldır'"
                      :selected-label="'Seçildi'" :select-label="'Seç'" />

                 
                  </div>
                </div>
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </div>

    <div class="col-lg-12" v-if="KullaniciAra && Tab ==1">
      <div class="card">
        <div class="card-body">
          <h5 class="h4 card-title">
            {{ this.$t("userroles.page.kullaniciyetkilendirmeekrani") }}
          </h5>
          <p class="card-title-desc">
            {{ this.$t("userroles.page.ekampusicin") }}
            <code>{{ KullaniciAra.label }}</code>
            {{ this.$t("userroles.page.yetkilendirmeekrani") }}
          </p>

          <div class="row">
            <div
              class="col-lg-4"
              v-for="(RollerGrup, index) in KullaniciRolleriGrup"
              :key="index"
            >
              <div class="mt-4 mt-lg-0" v-if="RollerGrup[0].Group == 'Talep Yönetim Sistemi'">
                <h5 class="font-size-14 mb-3 w-100" >
                  {{ RollerGrup[0].Group }}
                </h5>

                <div
                  class="form-check form-switch form-switch-md mb-3"
                  v-for="(Roller, index) in RollerGrup"
                  :key="index"
                >
                  <input v-if="Roller.Name != 'TlpTahsilat'"
                    type="checkbox"
                    class="form-check-input"
                    :id="Roller.Name"
                    v-model="Roles"
                    :value="Roller.Name"
                    @input="RolesPost($event.target.checked,$event.target.value)"
                  />
                  <label class="form-check-label" for="customSwitchsizemd"  v-if="Roller.Name != 'TlpTahsilat'">{{
                    Roller.Title
                  }}</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-lg-12" v-if="YetkiAra && Tab ==2">
      <div class="card">
        <div class="card-body">
          <h5 class="h4 card-title">
            {{ $t("userroles.page.yetkilikullanicilar") }}
          </h5>
          <p class="card-title-desc">
            {{ $t("userroles.page.listelenenyetki") }}
            <code>{{ YetkiAra }}</code>
            {{ $t("userroles.page.yetkilikullanicilar") }}
          </p>

          <div class="table-responsive">
            <table class="table align-middle table-nowrap table-hover">
              <thead class="table-light">
                <tr>
                  <th scope="col">{{ $t("userroles.table.FirstName") }}</th>
                  <th scope="col">{{ $t("userroles.table.LastName") }}</th>
                  <th scope="col">{{ $t("userroles.table.Email") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(Kullanici, index) in SeciliYetkiKullaniciliari"
                  :key="index"
                >
                  <td>{{ Kullanici.FirstName }}</td>
                  <td>{{ Kullanici.LastName }}</td>
                  <td>{{ Kullanici.Email }}</td>
                </tr>
              </tbody>
            </table>
            <b-pagination
              class="pagination pagination-rounded justify-content-end mb-2"
              v-model="DefaultPage"
              :total-rows="Page.PageDataSize"
              :per-page="Page.PageSize"
              aria-controls="my-table"
              @input="ChangePage($event, (Page.PageDataSize / Page.PageSize))"
            >
            </b-pagination>
          </div>
        </div>
      </div>
    </div>
 
    
  </Layout>
</template>
